import Paginate from './Paginate';

export default Paginate;